import { render, staticRenderFns } from "./ClickAndBuyFundraisingNumberForm.vue?vue&type=template&id=2a9da713&scoped=true"
import script from "./ClickAndBuyFundraisingNumberForm.vue?vue&type=script&lang=js"
export * from "./ClickAndBuyFundraisingNumberForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a9da713",
  null
  
)

export default component.exports